import { render } from "./Correspondence.vue?vue&type=template&id=0676a1d0"
import script from "./Correspondence.vue?vue&type=script&lang=js"
export * from "./Correspondence.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__